import AnswerMultipleChoices from './AnswerMultipleChoices';

export default AnswerMultipleChoices;
